import { Cloudinary } from 'cloudinary-core';
import _, { sortBy } from 'lodash';
import { useEffect, useState } from 'react';

import featuresConfig from './featuresConfig';
import cms_api from '../../../cms_api';
import { stringsFor } from '../../location/locales';

const algaeResistanceIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739664/shingles/features/icons/algae_resistance.svg';
const algaeResistanceIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739584/shingles/features/icons/algae_resistance_hover.svg';
const coolcolorIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739362/shingles/features/icons/iconcoolcolor.svg';
const coolcolor20Icon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739295/shingles/features/icons/iconcoolcolor20.svg';
const coolcolorFlagIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739039/shingles/features/icons/flagcoolcolor.svg';
const coolcolor20FlagIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674738932/shingles/features/icons/flagiconcoolcolor20.svg';

const sbsIcon = 'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746407/shingles/features/icons/sbs.svg';
const sbsIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746323/shingles/features/icons/sbs_hover.svg';
const surenailIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746272/shingles/features/icons/surenail.svg';
const surenailIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746223/shingles/features/icons/surenail_hover.svg';
const trudefinitionIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746173/shingles/features/icons/trudefinition.svg';
const trudefinitionIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746129/shingles/features/icons/trudefinition_hover.svg';
const warranty25Icon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746056/shingles/features/icons/warranty25.svg';
const warranty25IconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741520/shingles/features/icons/warranty25_hover.svg';
const warranty25Image =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741474/shingles/features/warranty_25_feature.png';
const warrantyLifetimeIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741425/shingles/features/icons/warranty_lifetime.svg';
const warrantyLifetimeIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741370/shingles/features/icons/warranty_lifetime_hover.svg';
const warrantyLifetimeImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741313/shingles/features/warranty_lifetime_feature.png';
const weatherguardIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741264/shingles/features/icons/weatherguard.svg';
const weatherguardIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741202/shingles/features/icons/weatherguard_hover.svg';
const windResistanceHighIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_svg,q_auto/v1678288703/shingles/wind_resistances/icons/high-wind.svg';
const windResistanceHighIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,co_rgb:d40f7d,e_colorize,dpr_2.0,w_20,h_20/v1678288703/shingles/wind_resistances/icons/high-wind.svg';
const windResistanceLowIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_svg,q_auto/v1678292659/shingles/wind_resistances/icons/low-wind.svg';
const windResistanceLowIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,co_rgb:d40f7d,e_colorize,dpr_2.0,w_20,h_20/v1678292659/shingles/wind_resistances/icons/low-wind.svg';
const windResistanceMediumIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_svg,q_auto/v1678288703/shingles/wind_resistances/icons/medium-wind.svg';
const windResistanceMediumIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,co_rgb:d40f7d,e_colorize,dpr_2.0,w_20,h_20/v1678288703/shingles/wind_resistances/icons/medium-wind.svg';
// Cloudinary images - USE THOSE IF POSSIBLE
const newColorIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1611672982/roofing/shingles/icons/vibrant-dimensional-color.svg';
const newColorIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1611672977/roofing/shingles/icons/vibrant-dimensional-color-hover.svg';
const newColorModalImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,w_250,q_80/v1611773148/roofing/shingles/modals/premium-color-blends.jpg';
const newColorImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,w_470,q_60/v1611773376/roofing/shingles/features/premium-color-blends.jpg';

const algaeResistanceImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674740128/shingles/features/algae_resistance.jpg';
const coolcolorImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674740067/shingles/features/coolcolor.png';
const coolcolor20Image =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739927/shingles/features/coolcolor_20.jpg';
const sbsImage = 'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739878/shingles/features/sbs.jpg';
const surenailImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739818/shingles/features/surenail.png';
const trudefinitionImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739770/shingles/features/trudefinition.jpg';
const weatherguardImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739717/shingles/features/weatherguard.jpg';
const windResistanceImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674738803/shingles/features/wind_resistance.jpg';

const currentLocale = document.querySelector('html').getAttribute('lang');
const featureTranslations = stringsFor(currentLocale).shingles.features;

export const ENABLED_FEATURE_FLAGS = ['scoty', 'coolcolor', 'cool-20-plus', 'newcolor'];

const CATEGORY_ORDER = ['feature', 'warranty', 'wind_resistance', 'impact_resistance', 'energy'];

const calculateOrder = (category, positionInCategory) => {
  const categoryIndex = CATEGORY_ORDER.indexOf(category);
  const categoryBase = categoryIndex * 100;
  return categoryBase + positionInCategory;
};

class Feature {
  constructor(props) {
    Object.assign(this, {
      category: 'feature',
      analyticsName: featuresConfig.features.analytics.name,
      excludeFromFeaturesList: false,
      ...props,
    });

    if (featureTranslations[this.key]) {
      Object.assign(this, featureTranslations[this.key]);
    }
  }

  itemAttributes(item) {
    return null;
  }

  isIncludedIn(shingle) {
    return shingle[this.key];
  }

  isInShingleOrColor(shingle) {
    return this.isIncludedIn(shingle) || (shingle.shingle_colors || []).some(sc => this.isIncludedIn(sc));
  }

  shouldShowFlag(shingle) {
    return this.isIncludedIn(shingle);
  }
}

class Warranty extends Feature {
  constructor(props) {
    super({ category: 'warranty', analyticsName: featuresConfig.warranties.analytics.name, ...props });
  }

  isIncludedIn(shingle) {
    return shingle.warranty == this.name;
  }
}

class WindResistance extends Feature {
  constructor(props) {
    super({ category: 'wind_resistance', analyticsName: featuresConfig.windResistances.analytics.name, ...props });
  }

  isIncludedIn(shingle) {
    return shingle.wind_resistance == this.value;
  }
}

class ShingleColorFeature extends Feature {
  shingleColorFeature = true;
}

class NewColorFeature extends ShingleColorFeature {
  isIncludedIn(shingle) {
    return false;
  }

  shouldShowFlag(shingle) {
    return shingle[this.key];
  }
}

let features = [
  {
    key: 'weatherguard',
    icon: weatherguardIcon,
    iconHover: weatherguardIconHover,
    image: weatherguardImage,
    analyticsOption: featureTranslations.weatherguard.data_track_destination,
  },
  {
    key: 'surenail',
    icon: surenailIcon,
    iconHover: surenailIconHover,
    image: surenailImage,
    url: featureTranslations.surenail.url,
    analyticsOption: featureTranslations.surenail.data_track_destination,
  },
  {
    key: 'trudefinition',
    icon: trudefinitionIcon,
    iconHover: trudefinitionIconHover,
    image: trudefinitionImage,
    analyticsOption: featureTranslations.trudefinition.data_track_destination,
  },
  {
    key: 'algae_resistance',
    icon: algaeResistanceIcon,
    iconHover: algaeResistanceIconHover,
    image: algaeResistanceImage,
    url: featureTranslations.algae_resistance.url,
    showDetails: 'bottom',
    analyticsOption: featureTranslations.algae_resistance.data_track_destination,
  },
  {
    key: 'sbs',
    icon: sbsIcon,
    iconHover: sbsIconHover,
    image: sbsImage,
    analyticsOption: featureTranslations.sbs.data_track_destination,
  },
].map((obj, index) => new Feature({ ...obj, order: calculateOrder('feature', index) }));

features = features.concat(
  [
    {
      key: 'newcolor',
      icon: newColorIcon,
      iconHover: newColorIconHover,
      image: newColorImage,
      modalImage: newColorModalImage,
      flagStyle: { height: 28, marginRight: 'auto', marginTop: 13 },
      showDetails: 'top',
      analyticsOption: featureTranslations.newcolor.data_track_destination,
    },
  ].map((obj, index) => new NewColorFeature({ ...obj, order: calculateOrder('feature', 5 + index) }))
);

features = features.concat(
  [
    {
      key: 'premium_color_blend',
      icon: newColorIcon,
      iconHover: newColorIconHover,
      image: newColorImage,
      modalImage: newColorModalImage,
      analyticsOption: featureTranslations.premium_color_blend.data_track_destination,
    },
  ].map((obj, index) => new ShingleColorFeature({ ...obj, order: calculateOrder('feature', 6 + index) }))
);

features = features.concat(
  [
    {
      key: 'warranty25',
      icon: warranty25Icon,
      iconHover: warranty25IconHover,
      image: warranty25Image,
      url: '/roofing/warranty',
      extraUrl: 'https://www.owenscorning.com/roofing/warranty/#manage-warranty',
      showDetails: 'top',
      analyticsOption: featureTranslations.warranty25.data_track_destination,
    },
    {
      key: 'warrantyLifetime',
      icon: warrantyLifetimeIcon,
      iconHover: warrantyLifetimeIconHover,
      image: warrantyLifetimeImage,
      url: '/roofing/warranty',
      extraUrl: 'https://www.owenscorning.com/roofing/warranty/#manage-warranty',
      showDetails: 'top',
      analyticsOption: featureTranslations.warrantyLifetime.data_track_destination,
    },
  ].map((obj, index) => new Warranty({ ...obj, order: calculateOrder('warranty', index) }))
);

features = features.concat(
  [
    {
      ...featureTranslations.wind_resistance.high,
      key: 'wind_resistance_high',
      icon: windResistanceHighIcon,
      iconHover: windResistanceHighIconHover,
      image: windResistanceImage,
      url: '/roofing/warranty',
      showDetails: 'top',
      value: '130 MPH | 209 KMH',
      analyticsOption: featureTranslations.wind_resistance.high.data_track_destination,
    },
    {
      ...featureTranslations.wind_resistance.medium,
      key: 'wind_resistance_medium',
      icon: windResistanceMediumIcon,
      iconHover: windResistanceMediumIconHover,
      image: windResistanceImage,
      url: '/roofing/warranty',
      showDetails: 'top',
      value: '110/130 MPH | 177/209 KMH',
      analyticsOption: featureTranslations.wind_resistance.medium.data_track_destination,
    },
    {
      ...featureTranslations.wind_resistance.low,
      key: 'wind_resistance_low',
      icon: windResistanceLowIcon,
      iconHover: windResistanceLowIconHover,
      image: windResistanceImage,
      url: '/roofing/warranty',
      showDetails: 'top',
      value: '60 MPH | 97 KMH',
      analyticsOption: featureTranslations.wind_resistance.low.data_track_destination,
    },
  ].map((obj, index) => new WindResistance({ ...obj, order: calculateOrder('wind_resistance', index) }))
);

class ImpactResistance extends Feature {
  constructor(props) {
    super({ category: 'impact_resistance', analyticsName: featuresConfig.impactResistances.analytics.name, ...props });
  }

  isIncludedIn(shingle) {
    return shingle.impact_resistance_uid == this.value;
  }
}

features = features.concat(
  [
    {
      key: 'class-3',
      value: 'class-3',
    },
    {
      key: 'class-4',
      value: 'class-4',
    },
    {
      key: 'class-5',
      value: 'class-5',
    },
  ].map((obj, index) => new ImpactResistance({ ...obj, order: calculateOrder('impact_resistance', index) }))
);

// Add SCOTY features
class Scoty extends Feature {
  constructor(props) {
    super({
      category: '',
      excludeFromFeaturesList: true,
      ...props,
    });
  }

  itemAttributes(color) {
    const lookup = this.scotys[color.scoty_uid];
    if (!lookup) {
      return null;
    }
    const { image: { file, alt } = {} } = lookup;

    const [root, path] = file?.split('/image/upload/') || [];
    const [cloudname, unused] = root?.split('/').reverse() || [];

    const cloudinary = cloudname
      ? new Cloudinary({
          cloud_name: cloudname,
          secure: true,
        })
      : null;

    return {
      flagIcon: cloudinary?.url(path, {
        transformation: [
          {
            crop: 'scale',
            width: 209,
            height: 209,
            quality: 'auto',
            fetchFormat: 'auto',
          },
        ],
        type: 'upload',
      }),
      flagAlt: alt,
    };
  }

  isIncludedIn(color) {
    return !!this.scotys[color.scoty_uid];
  }
}

features = features.concat([
  new Scoty({
    key: 'scoty',
    order: calculateOrder('feature', 2),
  }),
]);

class EnergyFeatures extends Feature {
  tiers = ['coolcolor', 'cool-20-plus'];

  shingleColorFeature = true;

  constructor(props) {
    super({ category: 'feature', ...props });
    this.isIncludedIn = this.isIncludedIn.bind(this);
  }

  inSRIRange(obj) {
    const sri = parseInt(obj.sri) || -1;
    return sri >= this.minSRI;
  }

  shouldShowFlag(obj) {
    // Note: this works only on the leaf
    const currentLevel = this.tiers.indexOf(this.key);
    const higherLevels = this.tiers.slice(currentLevel + 1);
    // If we find higher level _flag_ we return false.
    for (const level of higherLevels) {
      const feature = features.find(f => f.key == level);
      if (feature.isIncludedIn(obj)) return false;
    }
    return obj[this.key] || this.inSRIRange(obj);
  }

  isIncludedIn(obj) {
    return obj[this.key] || this.inSRIRange(obj);
  }
}
// SRI features
features = features.concat(
  [
    {
      key: 'coolcolor',
      icon: coolcolorIcon,
      iconHover: coolcolorIcon,
      flagIcon: coolcolorFlagIcon,
      image: coolcolorImage,
      analyticsOption: featureTranslations.coolcolor.data_track_destination,
      minSRI: 16,
    },
    {
      key: 'cool-20-plus',
      icon: coolcolor20Icon,
      iconHover: coolcolor20Icon,
      flagIcon: coolcolor20FlagIcon,
      image: coolcolor20Image,
      minSRI: 20,
    },
  ].map((obj, index) => new EnergyFeatures({ ...obj, order: calculateOrder('energy', index) }))
);

const getScotyData = _.memoize(
  async code =>
    await cms_api.get_single_contents({
      filter: {
        type: 'Cms::Content::Attribute',
        language_iso_code: code,
        route: '/roofing',
        name: 'Shingle Color of the Year (SCOTY) Badges',
      },
      fields: {
        '*': 'contents',
      },
    })
);

const getImpactResistanceData = _.memoize(
  async code =>
    await cms_api.get_single_contents({
      filter: {
        type: 'Cms::Content::Attribute',
        language_iso_code: code,
        route: '/roofing',
        name: 'Impact Resistance',
      },
      fields: {
        '*': 'contents',
      },
    })
);

const asyncFeatureFactory = async () => {
  const [scotyAttribute, impactResistantAttribute] = await Promise.all([
    getScotyData(currentLocale),
    getImpactResistanceData(currentLocale),
  ]);

  const scotyFeature = features.find(f => f.key === 'scoty');
  if (scotyFeature && scotyAttribute?.items?.length > 0) {
    scotyFeature.scotys = _.keyBy(scotyAttribute.items, i => i.value);
  } else {
    features = features.filter(f => f.key !== 'scoty');
  }

  if (impactResistantAttribute?.items?.length > 0) {
    features
      .filter(f => f.category === 'impact_resistance')
      .forEach(feature => {
        const lookups = _.keyBy(impactResistantAttribute.items, i => i.value);
        const item = lookups[feature.key];
        if (item) {
          feature.singular = impactResistantAttribute.singular;
          feature.icon = item.icon.file;
          feature.iconHover = item.icon.file;
          feature.alt = item.icon.alt;
          feature.name = item.label;
          if (item.details && item.details.reusable) {
            feature.title = item.details.title;
            feature.reusable = item.details.reusable;
            feature.description = 'dummy to make the icon on row work';
          }
        }
      });
  }

  return sortBy(features, 'order');
};
export default asyncFeatureFactory;

export const useFeatures = () => {
  const [allRoofingFeatures, setAllRoofingFeatures] = useState();
  useEffect(() => {
    asyncFeatureFactory().then(features => setAllRoofingFeatures(features));
  }, []);
  return allRoofingFeatures;
};
